import { gql } from '@apollo/client';

const GET_STUDENT = gql`
  query getStudent($where: StudentWhereInput!) {
    student(where: $where) {
      id
      firstName
      lastName
    }
  }
`;

export default GET_STUDENT;
